import { SET_ST_SUPPLIER_DATA, ADD_ST_SUPPLIER_DATA, DELETE_ST_SUPPLIER_DATA, EDIT_ST_SUPPLIER_DATA, ADD_COUNTRIES, UPDATE_COUNTRIES, ADD_STATES } from "../action/types";

const initialState = { supplierData: [], countries: [], states: [] };

const subTierSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ST_SUPPLIER_DATA:
      return { ...state, supplierData: action.payload };
    case ADD_ST_SUPPLIER_DATA:
      let newData = [...state.supplierData];
      newData = newData.concat(action.payload);
      return { ...state, supplierData: newData };
    case DELETE_ST_SUPPLIER_DATA:
      let modifiedData = [...state.supplierData];
      modifiedData.forEach((d) => {
        if (d.id === action.payload) d.deletedByUser = true;
      });
      return { ...state, supplierData: modifiedData };
    case EDIT_ST_SUPPLIER_DATA:
      let editedData = [...state.supplierData];
      editedData.forEach((data) => {
        if (data.id === action.payload.id) {
          if (!data.addedByUser) data.editedByUser = true;
          for (const key in data) {
            if (action.payload.hasOwnProperty([key + "err"])) {
              data[key + "err"] = action.payload[key + "err"];
            }
          }
          if (action.payload.field === "country" && data[action.payload.field] !== action.payload.value) {
            data.state = "";
          }
          data[action.payload.field] = action.payload.value;
        }
      });
      return { ...state, supplierData: editedData };
    case ADD_COUNTRIES:
      return { ...state, countries: action.payload };
    case UPDATE_COUNTRIES:
      let toUpdate = [...state.countries];
      let breakloop = false;
      for (let i = 0; i < toUpdate.length; i++) {
        for (let j = 0; j < action.payload.length; j++) {
          if (toUpdate[i].iso2CountryCode === action.payload[j].iso2CountryCode) {
            toUpdate[i].states = action.payload[j].states;
            breakloop = true;
            break;
          }
        }
        if (breakloop) break;
      }
      return { ...state, countries: toUpdate };
    case ADD_STATES:
      let statesUpdated = [...state.states];
      return { ...state, states: statesUpdated.concat(action.payload) };
    default:
      return state;
  }
};

export default subTierSurveyReducer;
